const ctaText = {
  ADD_TO_BAG: "Add to Bag",
  ADDED_TO_BAG: "Added to Bag",
  ADDING: "Adding to Bag",
  START_NEW_SHIPMENT: "Start New Shipment",
  UNAVAILABLE: "Unavailable",
  CHOOSE_RENTAL_PERIOD: "Choose Rental Period",
  ADD_TO_SHIPMENT: "Add to Shipment",
  REACTIVATE_SUBSCRIPTION: "Reactivate Subscription",
  UPGRADE_YOUR_PLAN: "Upgrade Your Plan",
  JOIN_NOW: "Join Now",
  RESERVING: "Reserving",
  LOADING: "Loading",
};

export default ctaText;

export const {
  ADD_TO_BAG,
  ADDED_TO_BAG,
  ADDING,
  START_NEW_SHIPMENT,
  UNAVAILABLE,
  CHOOSE_SIZE,
  CHOOSE_RENTAL_PERIOD,
  ADD_TO_SHIPMENT,
  REACTIVATE_SUBSCRIPTION,
  UPGRADE_YOUR_PLAN,
  JOIN_NOW,
  RESERVING,
} = ctaText;
